import { ChipProps } from '@mui/material';
import { DefectStatusEnum, DefectTypeEnum } from '../types';

export const DEFECT_STATUS_COLOR = {
    [DefectStatusEnum.OPEN]: 'primary' as ChipProps['color'],
    [DefectStatusEnum.CLOSED]: 'default' as ChipProps['color'],
};

export const DEFECT_TYPE_COLOR = {
    product: 'default' as ChipProps['color'],
    autotest: 'default' as ChipProps['color'],
};

export const defectStatuses = Object.values(DefectStatusEnum);
export const defectTypes = Object.values(DefectTypeEnum);
